import type { ReactNode } from 'react';

import { Label as LabelPrimitive } from '@connected/ui/components/label';
import { cn } from '@connected/ui/lib/utils';

export type LabelProps = {
    children: ReactNode;
    label?: ReactNode;
    className?: string;
    slot?: ReactNode;
    htmlFor?: string;
    style?: React.CSSProperties;
};

export function Label({
    label,
    children,
    htmlFor,
    className,
    slot,
    style,
}: LabelProps) {
    if (htmlFor !== undefined) {
        return (
            <div className={cn('flex flex-col gap-1', className)}>
                <LabelPrimitive htmlFor={htmlFor} className={cn('flex flex-col gap-1 ', className)} style={style}>
                    {label && (
                        <div className="flex justify-between">
                            <span className="text-sm font-medium text-text-secondary">{label}</span>
                            {slot}
                        </div>
                    )}
                </LabelPrimitive>
                {children}
            </div>
        );
    }

    return (
        <LabelPrimitive className={cn('flex flex-col gap-1', className)} style={style}>
            <>
                {label && (
                    <div className="flex justify-between">
                        <span className="text-sm font-medium text-text-secondary">{label}</span>
                        {slot}
                    </div>
                )}
                {children}
            </>
        </LabelPrimitive>
    );
}
